module.exports = __webpack_public_path__ + "static/media/Linotype - HelveticaNeueLTStd-Md.dafc64e4.ttf";